module.exports = __webpack_public_path__ + "loader-b922920ac5f8710931ae.gif";